import { ThemeProvider } from 'styled-components'
import PropTypes from 'prop-types'
import DefaultTheme from '@web-ui-kit/themes.default-theme'
import MladinskaFonts from 'assets/styles/MladinskaFonts'
import { isMladinskaPublisher } from 'utils'

const ThemePublisher = ({ children, publishers }) => {
  const mladinskaTheme = {
    colors: {
      ACCENT_100: '#D9DDF2',
      ACCENT_20: '#F8F9FD',
      ACCENT_200: '#B3BBE6',
      ACCENT_300: '#8C99D9',
      ACCENT_400: '#6677CC',
      ACCENT_50: '#ECEEF9',
      ACCENT_500: '#4055BF',
      ACCENT_600: '#334499',
      ACCENT_700: '#263373',
      ACCENT_800: '#19224D',
      ACCENT_900: '#0D1126',
      SECONDARY_100: '#ECEEF9',
      SECONDARY_200: '#D9DDF2',
      SECONDARY_900: '#6677CC',
    },
    fonts: {
      body: 'DIN Next LT Pro',
      heading: 'DIN Next LT Pro',
    },
  }
  const isMladinska = isMladinskaPublisher(publishers)
  const theme = isMladinska ? mladinskaTheme : DefaultTheme
  return (
    <ThemeProvider theme={theme}>
      {isMladinska && <MladinskaFonts />}
      {children}
    </ThemeProvider>
  )
}

ThemePublisher.propTypes = {
  children: PropTypes.node.isRequired,
  publishers: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    })
  ),
}

ThemePublisher.defaultProps = {
  publishers: [],
}

export default ThemePublisher
